export default "__VITE_ASSET__36324030__"